import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { Registration } from '@app/account/models/registration.model';
import { AuthorizationResponse } from '@app/account/models/authorization-response.model';
import { Response } from '../interfaces/response';
import { AuthCredentials } from '../interfaces';
import { Store } from '@ngrx/store';
import { LogoutRequested } from '../store/auth/auth.actions';
import { ResetPasswordResponse } from '@app/account/models/reset-password-response.model';

enum ep {
  Login = '/auth/login',
  Register = '/auth/register',
  Users = '/auth/users/'
}

@Injectable()
export class AuthenticationService {
  constructor(private http: HttpClient, private store: Store) {}

  register$(userRegistration: Registration): Observable<Response> {
    return this.http.post<Response>(
      environment.apiUrl + ep.Register,
      userRegistration
    );
  }

  verify$(userId: string, token: string): Observable<Response> {
    return this.http.post<Response>(`${environment.apiUrl}/auth/verify`, {
      userId,
      token
    });
  }

  login$(authCredentials: AuthCredentials): Observable<AuthorizationResponse> {
    return this.http.post<AuthorizationResponse>(
      environment.apiUrl + ep.Login,
      authCredentials
    );
  }

  forgotPassword$(email: string | null | undefined): Observable<Response> {
    return this.http.post<Response>(`${environment.apiUrl}/auth/forgot-password`, {
      email
    });
  }

  resetPassword$(
    userId: string | null,
    resetPasswordToken: string | null,
    newPassword: string | null | undefined): Observable<ResetPasswordResponse> {
    return this.http.put<ResetPasswordResponse>(
      `${environment.apiUrl}/auth/reset-password-with-token`,
      {
        userId,
        resetPasswordToken,
        newPassword
      }
    );
  }

  changePassword$(
    id: string,
    currentPassword: string,
    password: string
  ): Observable<Response> {
    return this.http.post<Response>(
      `${environment.apiUrl}/auth/password_change`,
      {
        id,
        currentPassword,
        password
      }
    );
  }

  refreshAuthContext$() {
    return this.http.get<AuthorizationResponse>(`${environment.apiUrl}/auth/refresh-token`);
  }

  logOut(){
    this.store.dispatch(LogoutRequested());
  }
}
